import { HTMLProps } from 'react';
import cx from 'classnames';

import styles from './SetMembershipPrice.PriceSelect.module.scss';

export type PriceSelectProps = Pick<HTMLProps<HTMLDivElement>, 'className'> & {
  value: number;
  options: Option[];
  onChange(value: number): void;
};

export type Option = {
  value: number;
  label: string;
};

const PriceSelect = ({ className, value, options, onChange }: PriceSelectProps) => {
  const handleChange = e => onChange(e.target.value);

  return (
    <div className={cx(styles.container, className)}>
      <select value={value} onChange={handleChange}>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <div className={styles.label}>
        <p>The price of monthly subscription</p>
        <span>Per person, per month</span>
      </div>
    </div>
  );
};

export default PriceSelect;
